var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "제품 및 솔루션",
      "sc": "에프원시큐리티는 다방면으로 파트너의 정보를 보호합니다",
      "tabActive": "F1 WSFINDER",
      "icon": "/images/sub/visual/sv3-icon.svg",
      "bg": "/images/sub/visual/sv3.png"
    }
  }), _c('section', {
    staticClass: "sub-section-sm sub-section-sm--first"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title mb-32 mb-lg-56"
  }, [_c('h3', {
    staticClass: "sub-tit--lg text-center mb-30 mb-lg-44",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 웹셸(Web Shell) 이란? ")]), _c('p', {
    staticClass: "sub-tit--sm text-center"
  }, [_vm._v(" 웹셸은 공격자가 원격에서 웹서버에 명령을 수행할 수 있도록 작성한 웹스크립트(asp, php, jsp, cgi) 파일을 의미합니다 ")])]), _c('v-row', [_c('v-col', {
    staticClass: "mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "img-cap-wrap"
  }, [_c('div', {
    staticClass: "w-100 radius-lg bg-grey pa-16 pt30 py-md-40 py-lg-80"
  }, [_c('v-img', {
    staticClass: "d-block mx-auto",
    attrs: {
      "max-width": "420",
      "src": "/images/sub/products/ws/s1-img.png"
    }
  })], 1), _c('p', {
    staticClass: "img-cap font-size-12 font-size-lg-16 color-white font-weight-bold text-center d-flex align-center justify-center bg-gra"
  }, [_vm._v(" 인터넷환경 ")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('div', {
    staticClass: "pl-xl-40 pt-lg-54"
  }, [_c('p', {
    staticClass: "page-text-lg color-point mb-10 mb-lg-20 font-weight-bold"
  }, [_vm._v(" 웹페이지 약어인 ‘웹(Web)’ 과 서버에게 명령을 내려 실행하기 위한 인터페이스 역할을 하는 ‘셸(Shell)’의 합성어 입니다. ")]), _c('p', {
    staticClass: "page-text-lg color-gray mb-10 mb-lg-20"
  }, [_vm._v(" 웹페이지에서 서버에게 명령어를 실행하기 위하여 만들어진 프로그램 으로 원격에서 웹서버에 명령을 수행할 수 있도록 작성한 웹스크립트(asp, php, jsp, cgi 등)의 형태를 가집니다. ")]), _c('p', {
    staticClass: "page-text-lg color-gray mb-10 mb-lg-20"
  }, [_vm._v(" 웹서버의 다양한 취약점 "), _c('br'), _vm._v(" (서버 취약점, 웹 어플리케이션 취약점 등)을 타깃으로 공격하여 웹서버에 웹셸을 업로드 한 후 일반적인 웹 브라우저 (80port)를 통하여 업로드한 웹셸을 실행하여 침투한 서버상의 정보 유출 및 변조, 악성코드 유포 등의 불법 행위를 행하는 형태가 많습니다. ")]), _c('p', {
    staticClass: "page-text-lg color-gray"
  }, [_vm._v(" APT(Advanced Persistent Threat) 공격의 수단으로 활용 합니다. ")])])])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section-sm"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" 웹셸 관리시스템 ")]), _c('div', {
    staticClass: "border radius-md"
  }, [_c('div', {
    staticClass: "my-30 w-100 px-16"
  }, [_c('v-img', {
    staticClass: "d-block mx-auto mb-6 mb-lg-10",
    attrs: {
      "max-width": "529",
      "src": "/images/sub/products/ws/s2-img.png"
    }
  }), _c('p', {
    staticClass: "page-text-lg line-height-1 font-weight-bold text-center"
  }, [_vm._v("구현전략")])], 1), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "border-top border-right border-color-light",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex bg-point justify-center align-center py-14 border-bottom border-color-light"
  }, [_c('v-img', {
    staticClass: "d-block mr-6 mr-lg-10",
    attrs: {
      "max-width": "30",
      "src": "/images/sub/products/ws/s2-icon1-1.png"
    }
  }), _c('p', {
    staticClass: "page-text-sm font-weight-bold color-white text-center"
  }, [_vm._v(" 웹셸 탐지 구현 방안 ")])], 1), _c('div', {
    staticClass: "py-10 border-bottom border-color-light"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/arrow-bottom.png"
    }
  })], 1), _c('div', {
    staticClass: "py-10 border-bottom border-color-light bg-grey"
  }, [_c('p', {
    staticClass: "page-text-sm font-weight-bold color-point text-center"
  }, [_vm._v(" 웹셸 탐지 기술 적용 ")])]), _c('div', {
    staticClass: "pa-16 px-md-40 py-md-34"
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 패턴탐지 기술적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 파일기반 탐지 기술적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 유사도 탐지 기술적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 난독화 탐지 기술적용 ")])])]), _c('v-col', {
    staticClass: "border-top border-right border-color-light",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex bg-point justify-center align-center py-14 border-bottom border-color-light"
  }, [_c('v-img', {
    staticClass: "d-block mr-6 mr-lg-10",
    attrs: {
      "max-width": "30",
      "src": "/images/sub/products/ws/s2-icon1-2.png"
    }
  }), _c('p', {
    staticClass: "page-text-sm font-weight-bold color-white text-center"
  }, [_vm._v(" 관리자 S/W 구현 방안 ")])], 1), _c('div', {
    staticClass: "py-10 border-bottom border-color-light"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/arrow-bottom.png"
    }
  })], 1), _c('div', {
    staticClass: "py-10 border-bottom border-color-light bg-grey"
  }, [_c('p', {
    staticClass: "page-text-sm font-weight-bold color-point text-center"
  }, [_vm._v(" 관리시스템 구축 ")])]), _c('div', {
    staticClass: "pa-16 px-md-40 py-md-34"
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 시각적 직관성 적용 최적 그래픽 환경 Dash-Board ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 악성 스크립트, 악성 URL, 해시정보 등 패턴 유형별 관리 체계 탐지패턴, 행위결과, 변종웹셸 유형별 웹셸 관리 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 사용자 정보 및 사용자 인증을 통한 에이전트 관리 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 웹셸 탐지 현황, 패턴 통계 정보 제공 ")])])]), _c('v-col', {
    staticClass: "border-top border-color-light",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex bg-point justify-center align-center py-14 border-bottom border-color-light"
  }, [_c('v-img', {
    staticClass: "d-block mr-6 mr-lg-10",
    attrs: {
      "max-width": "30",
      "src": "/images/sub/products/ws/s2-icon1-3.png"
    }
  }), _c('p', {
    staticClass: "page-text-sm font-weight-bold color-white text-center"
  }, [_vm._v(" 분석환경 외 기타 부문 ")])], 1), _c('div', {
    staticClass: "py-10 border-bottom border-color-light"
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/arrow-bottom.png"
    }
  })], 1), _c('div', {
    staticClass: "py-10 border-bottom border-color-light bg-grey"
  }, [_c('p', {
    staticClass: "page-text-sm font-weight-bold color-point text-center"
  }, [_vm._v(" 에이전트 부가 기능 적용 ")])]), _c('div', {
    staticClass: "pa-16 px-md-40 py-md-34"
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 악성 URL 탐지 기능 적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 실시간 탐지 기능 적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 패턴 업데이트 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 파일 스캔 / 검역소 기능 구현 ")])]), _c('div', {
    staticClass: "py-10 border-top border-bottom border-color-light bg-grey"
  }, [_c('p', {
    staticClass: "page-text-sm font-weight-bold color-point text-center"
  }, [_vm._v(" 기타 ")])]), _c('div', {
    staticClass: "pa-16 px-md-40 py-md-34"
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-10"
  }, [_vm._v(" - 웹셸의 분석결과 분류 기능 제공 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 에이전트 및 패턴의 배포 기능 제공 ")])])])], 1)], 1)])], 1), _c('section', {
    staticClass: "sub-section-sm sub-section--last"
  }, [_c('v-container', [_c('h3', {
    staticClass: "sub-tit--md text-center mb-26 mb-lg-42",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_vm._v(" F1-WSFinder 주요기능 요약 ")]), _c('div', {
    staticClass: "py-16 py-lg-42 border-bottom",
    staticStyle: {
      "border-top": "2px solid var(--v-primary-base)"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('div', {
    staticClass: "bg-grey radius-xl d-flex align-center justify-center",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/s3-icon1-1.png"
    }
  })], 1)]), _c('v-col', {
    staticClass: "d-flex d-lg-block justify-center pt-0 pt-lg-18",
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "page-text-lg font-weight-bold text-center text-lg-left"
  }, [_vm._v(" 웹셸/악성URL "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 탐지 ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 유사도 탐지, 난독화 탐지 등 탐지 기술의 적용으로 웹셸 분석 능력 고도화 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 웹 소스 내 발견된 웹셸에 대해 파일해시 비교방식을 채택하여 O(n) 성능을 발휘하는 알고리즘 적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 포함된 악성코드 삽입 URL 탐지 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 파일개수, 파일 크기에 제약 조건 없는 실시간 탐지, 예외 처리 기능 포함 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 주기탐지, 예약탐지, 실시간 탐지, 확장자 지정 탐지, 특정 폴더 예외처리 탐지 기능 ")])])], 1)], 1), _c('div', {
    staticClass: "py-16 py-lg-42 border-bottom"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('div', {
    staticClass: "bg-grey radius-xl d-flex align-center justify-center",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/s3-icon1-2.png"
    }
  })], 1)]), _c('v-col', {
    staticClass: "d-flex d-lg-block justify-center pt-0 pt-lg-18",
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "page-text-lg font-weight-bold text-center text-lg-left"
  }, [_vm._v(" 원격 관리 ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 원격 탐지 점검 내역 조회를 통한 원격 기술지원 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 탐지 파일에 대한 격리, 복원, 예외, 확인(승인) 및 이력 관리 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 사용자, 에이전트, 패턴, 웹쉡 세분화된 원격 관리 기능 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 시스템 패턴 자동 업데이트 및 Agent 원격 제어 ")])])], 1)], 1), _c('div', {
    staticClass: "py-16 py-lg-42 border-bottom"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('div', {
    staticClass: "bg-grey radius-xl d-flex align-center justify-center",
    staticStyle: {
      "width": "100px",
      "height": "100px"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto d-block",
    attrs: {
      "max-width": "48",
      "src": "/images/sub/products/ws/s3-icon1-3.png"
    }
  })], 1)]), _c('v-col', {
    staticClass: "d-flex d-lg-block justify-center pt-0 pt-lg-18",
    attrs: {
      "cols": "12",
      "lg": "2"
    }
  }, [_c('h6', {
    staticClass: "page-text-lg font-weight-bold text-center text-lg-left"
  }, [_vm._v(" 편리한 관리 UI ")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - GUI 기반의 사용자 UI 적용 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 통합 웹 UI (윈도우, 리눅스 등 Agent 유형에 상관없이 동일 사용자 인터페이스 지원) ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm mb-4 mb-lg-8"
  }, [_vm._v(" - 패턴/웹셸/사용자/에이전트 별도의 관리기능 부여 ")]), _c('p', {
    staticClass: "color-gray bar-txt page-text-sm"
  }, [_vm._v(" - 대시보드 및 통계 보고서 ")])])], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }